module.exports = __webpack_public_path__ + "img/bahamas.bb311b4d.svg";